// extracted by mini-css-extract-plugin
export var editButton = "_os-0";